import React, { useContext } from 'react';
import toast from 'react-hot-toast';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthPorvider';
import useAdmin from '../../hooks/useAdmin';
import Loading from '../../Pages/Shared/Loading/Loading';

const AdminRoute = ({ children }) => {
    const { user, loading, logOut } = useContext(AuthContext);
    const [isAdmin, isAdminLoading] = useAdmin(user?.email);
    // const location = useLocation();

    if (loading || isAdminLoading) {
        return <Loading></Loading>
    }

    if (user && isAdmin) {
        return children;
    }
    logOut()
        .then(result => {
            toast.error('UnAuthorize Accesss..');
            return <Navigate to="/login"></Navigate>
        })
        .then(error => { })

    // return <Navigate to="/login" state={{ from: location }} replace ></Navigate>


};

export default AdminRoute;